import React from 'react';
import { connect } from 'react-redux';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';

export const Cabecalho = () => (
  <thead>
    <tr>
      <th>Data e Hora</th>
      <th>Situação</th>
      <th>Usuário</th>
      <th>Observação</th>
    </tr>
  </thead>
);

export class ModalHistoricoEncomenda extends React.Component {
  exibirHistorico () {
    if (this.props.historicos && this.props.historicos.length) {
      return this.props.historicos.map(historico => (
        <tr key={`${historico.cod}-${historico.dataHora}`}>
          <td>{historico.dataHora}</td>
          <td>{historico.descricaoSituacao}</td>
          <td>{capitalizarTodasPrimeirasLetras(historico.nomeUsuario)}</td>
          <td>{historico.observacao ? historico.observacao : '—'}</td>
        </tr>
      ));
    }
    return null;
  }

  render () {
    return (
      <div className="modal fade show" role="dialog"
           id="modalHistoricoEncomenda" aria-labelledby="modalHistoricoEncomenda" aria-hidden="true" data-backdrop="static">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
            <div className="vx-modal-header">
              <div className="vx-modal-title">
                <span className="material-icons">history</span>
                Histórico — Pedido {this.props.idPedido}
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close">
                <span className="material-icons">close</span>
              </button>
            </div>
            <div className="vx-modal-body">
              <div className="table-responsive">
                <table className="table table-sm table-striped table-bordered" style={{ fontSize: 13 }}>
                  <Cabecalho />
                  <tbody>
                    {this.exibirHistorico()}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="vx-modal-footer">
              <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export function mapStateToProps (state) {
  return {
    empresaSelecionada: state.empresaSelecionada,
  }
}

export default connect(mapStateToProps,
  {})(ModalHistoricoEncomenda)
